var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "charge-breakdown-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "charge-breakdown",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "charge-breakdown__header" }, [
            _c(
              "h2",
              {
                staticClass: "charge-breakdown__title",
                attrs: { id: _vm.titleId },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("assistantCatHome.chargeBreakdownDialog.title")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "charge-breakdown__icon-close",
                attrs: { type: "button", "aria-label": _vm.$t("common.close") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("icon-close")],
              1
            ),
          ]),
          _c("div", { staticClass: "charge-breakdown__section" }, [
            _c("p", { staticClass: "charge-breakdown__label" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("assistantCatHome.chargeBreakdownDialog.chargeWeb")
                )
              ),
            ]),
            _c("div", { staticClass: "charge-breakdown__amount" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/icon/fish_icon.png"),
                  alt: _vm.$t("purchaseFish.product.fishIcon"),
                },
              }),
              _c("span", [_vm._v(_vm._s(_vm.webChargeLabel))]),
            ]),
          ]),
          _c(
            "button",
            {
              staticClass: "charge-breakdown__close",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }